export default [{
    title: "Inicio",
    route: "dashboard-general",
    icon: "HomeIcon",
    resource: "Publico",
    action: "ver-publico",
}]